import Vue from "vue";

Vue.directive("close-filter",
    {
        bind(el)
        {
            el.onclick = () =>
            {
                document.getElementsByClassName("mobile-filter")[0].classList.remove("open");
                document.getElementsByTagName("body")[0].classList.remove("noscroll");
            };
        }
    });
